import { MLHelper } from '@bimser/core';
import { BCButton, BCCombobox, BCPopover, findMessage } from '..';
import Styles from './assets/style.scss';
import Ai from '@bimser/icons/16/ai';
import * as React from 'react';
import { ITranslatePopoverProps } from './entitites';

export default function BCTranslatePopover(props: ITranslatePopoverProps) {
	const [languageValues, setLanguageValues] = React.useState({ source: '', target: '' });
	const [visible, setVisible] = React.useState(false);

	React.useEffect(() => {
		if (!props.isLoading) {
			setVisible(false);
		}
	}, [props.isLoading]);

	const updateSourceValue = newSourceValue => {
		setLanguageValues(prevValues => ({
			...prevValues,
			source: newSourceValue
		}));
	};

	const updateTargetValue = newTargetValue => {
		setLanguageValues(prevValues => ({
			...prevValues,
			target: newTargetValue
		}));
	};

	const onClick = () => {
		props.onClick && props.onClick(languageValues?.target, languageValues?.source);
	};

	const onOpenChange = () => {
		setVisible(!visible);
	};

	const sourceOptions = () => {
		if (!props.values && props.nullCheck) {
			return [];
		}

		const filterLanguages = item =>
			Object.keys(props.values).includes(item.culture) && props.values[item.culture] !== '';
		const mapLanguage = lang => ({
			text: lang.culture,
			key: lang.twoLetterCulture,
			value: lang.twoLetterCulture
		});

		return props.nullCheck
			? MLHelper.supportedLanguages.filter(filterLanguages).map(mapLanguage)
			: MLHelper.supportedLanguages.map(mapLanguage);
	};

	const content = () => (
		<div className={Styles.translatePopoverContent}>
			<span>{findMessage.get('101506')}</span>
			<BCCombobox
				showSearch={false}
				onSelectedChange={e => updateSourceValue(e.data)}
				value={languageValues.source}
				options={sourceOptions()}
			/>

			<span>{findMessage.get('100338')}</span>
			<BCCombobox
				showSearch={false}
				onSelectedChange={e => updateTargetValue(e.data)}
				value={languageValues.target}
				disabled={!languageValues.source}
				options={MLHelper.supportedLanguages
					.filter(lang => lang.twoLetterCulture !== languageValues.source)
					.map(lang => ({
						text: lang.culture,
						key: lang.twoLetterCulture,
						value: lang.twoLetterCulture
					}))}
			/>
			<BCButton
				text={findMessage.get('103044')}
				type="primary"
				onClick={onClick}
				size="middle"
				disabled={!languageValues.target}
				loading={props.isLoading}
			/>
		</div>
	);

	const renderToolbarItems = () => (
		<BCPopover
			content={content}
			title={findMessage.get('103043')}
			trigger="click"
			placement="bottom"
			open={visible}
			onOpenChange={onOpenChange}
			overlayClassName={Styles.translatePopoverContainer}
		>
			<BCButton icon={<Ai />}>{findMessage.get('103042')}</BCButton>
		</BCPopover>
	);

	return <>{props.canTranslate && <div>{renderToolbarItems()}</div>}</>;
}

export { ITranslatePopoverProps };
